var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-checkbox',{staticClass:"c2-parameter-checkbox",attrs:{"label":_vm.prop.name,"value":_vm.boolValue},on:{"input":_vm.toggleValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }